import React, { useEffect, useState } from "react"
import { navigate } from "gatsby"
import * as styles from "./desktop.module.less"
import Datepicker from "../DateAndTimepicker"
import moment from "moment-timezone"
import { format, isSameDay } from "date-fns"
import { cities } from "../../config"

const DesktopOnboardingForm = ({
  category = 1,
  ulClass = "",
  desktop = false,
}) => {
  // const {} = useContext(SpaceProfileContext)

  const [city, setCity] = useState(cities[0])
  const [teamSize, setTeamSize] = useState("")
  const [spaceType, setSpaceType] = useState("Private Offices")

  const [startDate, setSd] = useState(null)
  const [tempStartDate, setTempStartDate] = useState(null)

  const [endDate, setEd] = useState(null)

  const [startTime, setStartTime] = useState("")
  const [endTime, setEndTime] = useState("")

  const [tsOpen, setTsOpen] = useState(false)
  const [dpOpen, setDpOpen] = useState(false)
  const [progress, setProgress] = useState(false)

  const [isDaily, setIsDaily] = useState(true)
  const [displayDate, setDisplayDate] = useState("Start & End date")

  // const updateDate = dates => {
  //   const [start, end] = dates
  //   setSd(start)
  //   setEd(end)
  //   if (end) setDpOpen(false)
  // }

  useEffect(() => {
    setDpOpen(false)
    if (isDaily) {
      if (!startDate && !endDate) {
        setDisplayDate("Start & End date")
      }
      if (startDate && !endDate) {
        setDisplayDate(`${format(startDate, "MMMM d")} - End date`)
      }
      if (startDate && endDate) {
        if (isSameDay(startDate, endDate)) {
          setDisplayDate(`${format(startDate, "MMMM d")}`)
        } else {
          setDisplayDate(
            `${format(startDate, "MMMM d")} - ${format(endDate, "MMMM d")}`
          )
        }
      }
    } else {
      if (startDate && startTime && endTime) {
        setDisplayDate(
          `${format(startDate, "MMMM d")}, ${format(
            startTime,
            "h:mm a"
          )} - ${format(endTime, "h:mm a")}`
        )
      }
    }
  }, [endDate, endTime])

  useEffect(() => {
    setTsOpen(false)
    setTeamSize("")
  }, [category])

  const handleSearch = () => {
    if (teamSize === "") {
      setTsOpen(true)
      setDpOpen(false)
      return
    }
    setProgress(true)
    if (teamSize && city && category) {
      // navigate to the page
      const baseUrl =
        category === 2 ? `/${process.env.GATSBY_ON_DEMAND_SLUG}` : "/locations"
      let otherParts = `?current_staff=${teamSize}&location=${city}`
      if (category === 1) otherParts += `&space_type=${spaceType}`
      if (category === 2 && startDate)
        otherParts += `&move_in_date=${moment(startDate).format("YYYY-MM-DD")}`

      if (category === 2 && endDate) {
        otherParts += `&move_out_date=${moment(endDate).format("YYYY-MM-DD")}`
      } else if (category === 2 && startDate && !endDate) {
        otherParts += `&move_out_date=${moment(startDate).format("YYYY-MM-DD")}`
      }

      if (!isDaily) {
        if (startTime && endTime) {
          otherParts += `&on_demand_type=Hourly&start_time=${format(
            startTime,
            "h:mm a"
          )}&end_time=${format(endTime, "h:mm a")}`
        } else {
          setProgress(false)
          return
        }
      } else {
        otherParts += `&on_demand_type=Daily`
      }

      navigate(`${baseUrl}${otherParts}`)
    }
  }

  useEffect(() => {
    window.addEventListener("click", closeAll)
    return () => {
      window.removeEventListener("click", closeAll)
    }
  }, [])

  const closeAll = () => {
    setTsOpen(false)
    setDpOpen(false)
  }

  useEffect(() => {
    if (tempStartDate) {
      setEd(tempStartDate)
      setSd(tempStartDate)
      setTempStartDate(null)
    }
  }, [dpOpen])

  return (
    <ul
      className={`${ulClass} ${styles.content_list}`}
      onClick={(e) => e.stopPropagation()}
    >
      <li>
        <span>City</span>
        <select
          className={`form-control ${styles.city_selector}`}
          onClick={closeAll}
          value={city}
          onChange={(e) => setCity(e.target.value)}
        >
          {cities.map((item) => (
            <option value={item} key={item}>
              {item}
            </option>
          ))}
        </select>
      </li>
      <li className={category === 1 ? styles.no_border : ""}>
        <span>Seat Count</span>
        <button
          className="btn"
          onClick={(e) => {
            closeAll()
            e.stopPropagation()
            setTsOpen(true)
          }}
        >
          {teamSize === "" ? "Team Size" : teamSize}
        </button>
        {tsOpen && (
          <TeamSizeSelector
            category={category}
            teamSize={teamSize}
            setTeamSize={setTeamSize}
            close={() => setTsOpen(false)}
            setSpaceType={setSpaceType}
            desktop={desktop}
          />
        )}
      </li>
      {category === 2 && (
        <li
          className={`${styles.no_border} home_page_datepicker weekend-disabled`}
        >
          <span>Date</span>
          <button
            className="btn"
            onClick={() => {
              closeAll()
              setDpOpen(true)
            }}
          >
            {displayDate}
          </button>
          {dpOpen && (
            <div className={styles.home_page_picker}>
              <Datepicker
                setTempStartDate={setTempStartDate}
                setParentStartDate={setSd}
                setParentEndDate={setEd}
                setParentStartTime={setStartTime}
                setParentEndTime={setEndTime}
                isDaily={isDaily}
                setIsDaily={setIsDaily}
                startD={startDate}
                endD={endDate}
                startT={startTime}
                endT={endTime}
              />
            </div>
          )}
        </li>
      )}
      <li className={styles.search_button}>
        <button
          className={`btn btn-primary`}
          onClick={handleSearch}
          disabled={progress}
        >
          <img
            src={require("../../images/icons/search-white.svg").default}
            alt="Search"
            className={"d-none d-lg-block"}
          />
          <span className={"d-block text-center d-lg-none"}>
            Find workspace
          </span>
        </button>
      </li>
    </ul>
  )
}

export default DesktopOnboardingForm

const TeamSizeSelector = ({
  teamSize,
  setTeamSize = () => null,
  category = 1,
  close = () => null,
  setSpaceType = () => null,
  desktop = false,
}) => {
  const selectedSlots = category === 1 ? slots : slots2

  const [st, setSt] = useState(false)

  const handleChange = (value) => {
    setTeamSize(value.toString())
    if (Number(value) < 3 && category === 1) {
      // display the space type selector
      setSt(true)
    } else {
      close()
    }
  }

  const handleSt = (value) => {
    setSpaceType(value)
    close()
  }

  return (
    <div
      className={`${styles.team_size_selector} team-size-selector  ${
        desktop ? "picker-desktop show" : ""
      }`}
    >
      {st ? (
        <>
          <h5>What kind of workspace are you looking for? </h5>
          {["Private Offices", "Dedicated desks"].map((t) => (
            <button
              className="btn btn-primary"
              key={t}
              onClick={() => handleSt(t)}
            >
              {t}
            </button>
          ))}

          <a
            href="#"
            className={"btn btn-link chev-left"}
            onClick={() => setSt(false)}
          >
            Back
          </a>
        </>
      ) : (
        <>
          <h5>Team Size</h5>
          <ul>
            {selectedSlots.map((number) => (
              <li
                key={number}
                onClick={() => handleChange(number)}
                className={teamSize === number.toString() ? "active" : ""}
              >
                {number}
              </li>
            ))}

            {category === 1 && (
              <>
                <li
                  className={`long ${teamSize === "21-50" ? "active" : ""}`}
                  onClick={() => handleChange("21-50")}
                >
                  21-50
                </li>
                <li
                  className={`long ${teamSize === "51-100" ? "active" : ""}`}
                  onClick={() => handleChange("51-100")}
                >
                  51-100
                </li>
              </>
            )}
            {category === 2 && (
              <>
                <li
                  className={`long-3 ${teamSize === "13-20" ? "active" : ""}`}
                  onClick={() => handleChange("13-20")}
                >
                  13-20
                </li>
                <li
                  className={`long-3 ${teamSize === "21-30" ? "active" : ""}`}
                  onClick={() => handleChange("21-30")}
                >
                  21-30
                </li>
              </>
            )}
          </ul>
        </>
      )}
    </div>
  )
}

const slots = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
]

const slots2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
